module.exports = {
  __depends__: [ require(213) ],
  __init__: [ 'bpmnReplacePreview' ],
  bpmnReplacePreview: [ 'type', require(74) ]
};
